module.exports = __webpack_public_path__ + "static/media/Rigid_Hull_Boat_01.56b01180.jpg";